import React, { useCallback, useEffect, useState, useMemo } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import styles from '../styles/Testimonials.module.css';
import FaIcon from './FaIcon';

function useSlidesPerView() {
  const getCount = () => {
    const w = window.innerWidth;
    if (w <= 900) return 1;
    if (w <= 1200) return 2;
    return 3;
  };
  const [count, setCount] = useState(getCount);
  useEffect(() => {
    const onResize = () => setCount(getCount());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return count;
}

const FLAG_MAP = {
  'francese': '\u{1F1EB}\u{1F1F7}',
  'statunitense': '\u{1F1FA}\u{1F1F8}',
  'canadese': '\u{1F1E8}\u{1F1E6}',
  'spagnola': '\u{1F1EA}\u{1F1F8}',
  'spagnolo': '\u{1F1EA}\u{1F1F8}',
  'tedesca': '\u{1F1E9}\u{1F1EA}',
  'tedesco': '\u{1F1E9}\u{1F1EA}',
  'argentina': '\u{1F1E6}\u{1F1F7}',
  'argentino': '\u{1F1E6}\u{1F1F7}',
  'belga': '\u{1F1E7}\u{1F1EA}',
  'ungherese': '\u{1F1ED}\u{1F1FA}',
  'svedese': '\u{1F1F8}\u{1F1EA}',
  'americana': '\u{1F1FA}\u{1F1F8}',
  'brasiliana': '\u{1F1E7}\u{1F1F7}',
  'danese': '\u{1F1E9}\u{1F1F0}',
  'olandese': '\u{1F1F3}\u{1F1F1}',
  'messicana': '\u{1F1F2}\u{1F1FD}',
  'russa': '\u{1F1F7}\u{1F1FA}',
};

const TESTIMONIALS = [
  { message: "Bravi, il nuovo sito \u00e8 una grande meraviglia. Grazie!", name: "Marie", nationality: "francese" },
  { message: "Grazie mille per questi giochi molto divertenti!", name: "Jean Pierre", nationality: "francese" },
  { message: "E quando ho scoperto che questo sito \u00e8 stato disponibile, ero cos\u00ec felice!! Cerco di giocare a Giochini ogni giorno! Mi piacciono tutti i vostri giochi! Grazie per avere un ottimo sito per imparare meglio le parole italiane!!", name: "Diane", nationality: "statunitense" },
  { message: "Mi piacciono molto i giochi e cerco di giocare tutti i giorni.", name: "Helen", nationality: "canadese" },
  { message: "Mi fanno capire realmente non solo il significato delle parole, ma anche il vero collegamento tra di loro. Grazie mille per il gioco.", name: "Raquel", nationality: "spagnola" },
  { message: "Grazie mille per questo gioco davvero bello.", name: "Francesca", nationality: "francese" },
  { message: "Voglio ringraziarvi per il vostro contributo a quegli studenti, come me, che vogliono imparare la lingua italiana. I vostri giochi di parole sono molto divertenti e utili. Grazie mille!", name: "Monica", nationality: "argentina" },
  { message: "Le vostre storielle sono perfette per i miei studenti e gliele consiglio sempre. Ogni tanto le vediamo anche insieme a lezione.", name: "Stephanie", nationality: "statunitense" },
  { message: "Mi piacciono molto i vostri giochini.", name: "Anita", nationality: "belga" },
  { message: "Mi piacciono molto i Giochini di Parole, sono molto utili e divertenti.", name: "T\u00fcnde", nationality: "ungherese" },
  { message: "Grazie per i tuoi giochini, sono piacevoli.", name: "Lennart", nationality: "svedese" },
  { message: "Ti ringrazio per il tuo aiuto e soprattutto per i giochini che mi piacciono tanto. Buon lavoro!", name: "Sylves", nationality: "francese" },
  { message: "Mi piacciono i giochi, soprattutto per quando si hanno solo pochi minuti a disposizione.", name: "Claudia", nationality: "tedesca" },
  { message: "Grazie per la vostra dedizione e generosit\u00e0!", name: "Teresa", nationality: "spagnola" },
  { message: "I giochini, per me, sono diventati un bellissimo compagno di viaggio nel mio percorso quotidiano verso il lavoro. Grazie di cuore!", name: "Andrea", nationality: "tedesca" },
  { message: "\u00c8 geniale questo sito!", name: "Victoria", nationality: "francese" },
  { message: "Grazie per tutto il vostro lavoro. \u00c8 una app interessante e agile. Mi piace che non abbia un limite di tempo per completare un gioco.", name: "Ricardo", nationality: "argentino" },
  { message: "Ho consigliato la vostra app ai miei compagni di corso. Grazie per il vostro lavoro!", name: "Teresa", nationality: "spagnola" },
  { message: "Continuate cos\u00ec!", name: "Gabriella", nationality: "americana" },
  { message: "Mi piace tantissimo il vostro sito, sono proprio felice della vostra esistenza :-)))", name: "Mery", nationality: "spagnola" },
  { message: "Grazie per aver creato questi giochi. Mi divertono e mi aiutano a studiare. Li adoro!", name: "Andrea", nationality: "brasiliana" },
  { message: "\u00c8 un\u2019ottima possibilit\u00e0 di imparare l\u2019italiano in un modo divertente, ed \u00e8 adattabile al tempo disponibile di ognuno. Mi piace quando le parole difficili vengono ripetute dopo qualche giorno.", name: "Niels", nationality: "danese" },
  { message: "Grazie mille per questo gioco. Mi piace tantissimo e mi da l\u2019opportunit\u00e0 di non abbandonare del tutto l\u2019italiano.", name: "Raquel", nationality: "spagnola" },
  { message: "\u00c8 sempre molto divertente e utile giocare con la lingua italiana! Grazie per il vostro sforzo.", name: "Maddy", nationality: "olandese" },
  { message: "Grazie mille per il regalo di Giochini di Parole!", name: "Nieves", nationality: "spagnolo" },
  { message: "Mi piacciono molto i giochi!", name: "Miriam", nationality: "messicana" },
  { message: "Grazie mille per il vostro lavoro!", name: "Sasha", nationality: "russa" },
];

const chunkTestimonials = (items, size) => {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};

const Testimonials = () => {
  const slidesPerView = useSlidesPerView();
  const isMobile = slidesPerView === 1;
  const slidePercent = 100 / slidesPerView;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);
  const [mobileIndex, setMobileIndex] = useState(0);
  const mobileGroups = useMemo(() => chunkTestimonials(TESTIMONIALS, 3), []);

  const autoplayPlugin = useMemo(
    () => Autoplay({ delay: 10000, stopOnInteraction: false, stopOnMouseEnter: true }),
    []
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: 'start',
      slidesToScroll: isMobile ? 1 : slidesPerView,
    },
    [autoplayPlugin]
  );

  const scrollPrev = useCallback(() => {
    if (isMobile) {
      setMobileIndex((prev) => (prev - 1 + mobileGroups.length) % mobileGroups.length);
      return;
    }
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi, isMobile, mobileGroups.length]);

  const scrollNext = useCallback(() => {
    if (isMobile) {
      setMobileIndex((prev) => (prev + 1) % mobileGroups.length);
      return;
    }
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi, isMobile, mobileGroups.length]);

  const scrollTo = useCallback((index) => {
    if (isMobile) {
      setMobileIndex(index);
      return;
    }
    if (emblaApi) emblaApi.scrollTo(index);
  }, [emblaApi, isMobile]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    const syncSnaps = () => {
      setScrollSnaps(emblaApi.scrollSnapList());
      onSelect();
    };
    syncSnaps();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', syncSnaps);
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', syncSnaps);
    };
  }, [emblaApi, onSelect]);

  useEffect(() => {
    if (emblaApi) emblaApi.reInit({ slidesToScroll: isMobile ? 1 : slidesPerView });
  }, [emblaApi, isMobile, slidesPerView]);

  useEffect(() => {
    if (!isMobile) return;
    const interval = setInterval(() => {
      setMobileIndex((prev) => (prev + 1) % mobileGroups.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [isMobile, mobileGroups.length]);

  useEffect(() => {
    if (mobileIndex >= mobileGroups.length) {
      setMobileIndex(0);
    }
  }, [mobileIndex, mobileGroups.length]);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Dicono di noi</h2>
          <p className={styles.subtitle}>Le voci dei nostri giocatori dal mondo</p>
        </div>

        <div className={styles.carouselWrapper}>
          <button
            className={`${styles.arrowButton} ${styles.arrowPrev}`}
            onClick={scrollPrev}
            aria-label="Testimonianza precedente"
          >
            <FaIcon className="fas fa-chevron-left"  />
          </button>

          {isMobile ? (
            <div className={styles.mobilePager}>
              <div className={styles.mobileGroup}>
                {mobileGroups[mobileIndex].map((t, j) => (
                  <div className={`${styles.card} ${styles.mobileCard}`} key={`${t.name}-${mobileIndex}-${j}`}>
                    <div className={styles.quoteIcon}>
                      <FaIcon className="fas fa-quote-left"  />
                    </div>
                    <p className={styles.message}>{t.message}</p>
                    <div className={styles.author}>
                      <span className={styles.flag}>{FLAG_MAP[t.nationality] || ''}</span>
                      <span className={styles.authorName}>{t.name}</span>
                      <span className={styles.authorNationality}>{t.nationality}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.viewport} ref={emblaRef}>
              <div className={styles.track}>
                {TESTIMONIALS.map((item, i) => (
                  <div
                    className={styles.slide}
                    key={i}
                    style={{ flex: `0 0 ${slidePercent}%`, width: `${slidePercent}%`, maxWidth: `${slidePercent}%` }}
                  >
                    <div className={styles.card}>
                      <div className={styles.quoteIcon}>
                        <FaIcon className="fas fa-quote-left"  />
                      </div>
                      <p className={styles.message}>{item.message}</p>
                      <div className={styles.author}>
                        <span className={styles.flag}>{FLAG_MAP[item.nationality] || ''}</span>
                        <span className={styles.authorName}>{item.name}</span>
                        <span className={styles.authorNationality}>{item.nationality}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <button
            className={`${styles.arrowButton} ${styles.arrowNext}`}
            onClick={scrollNext}
            aria-label="Testimonianza successiva"
          >
            <FaIcon className="fas fa-chevron-right"  />
          </button>
        </div>

        {(isMobile ? mobileGroups.length : scrollSnaps.length) > 1 && (
          <div className={styles.dots}>
            {Array.from({ length: isMobile ? mobileGroups.length : scrollSnaps.length }).map((_, i) => (
              <button
                key={i}
                className={`${styles.dot} ${i === (isMobile ? mobileIndex : selectedIndex) ? styles.dotActive : ''}`}
                onClick={() => scrollTo(i)}
                aria-label={`Vai alla testimonianza ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
